import MobileConsentSolutionsList from './MobileConsentSolutionsList';

export default MobileConsentSolutionsList;
